import { LOAD_ERROR_MESSAGE } from 'mk/autogenerated/translations/Loading.849546df34e273a4f49e2134010ee382'
import { getLogger } from 'mk2/logger';
import * as React from 'react';
import { LoadingComponentProps } from 'react-loadable';
import styles from './Loading.mscss';

const logger = getLogger('components/Loading');

type Props = Pick<LoadingComponentProps, Exclude<keyof LoadingComponentProps, 'retry'>>;

const Loading: React.StatelessComponent<Props> = ({ error, pastDelay }) => {
    if (error) {
        logger.error(error);
        return (
            <div>
                <i className="fa fa-exclamation-triangle" />
                {LOAD_ERROR_MESSAGE}
           </div>
        );
    } else if (pastDelay) {
        return (
            <div className={styles.Loading}>
                <i className="fa fa-spin fa-spinner" />
            </div>
        );
    } else {
        return null;
    }
};

export default Loading;
